import { render } from "./ParticleSphere.vue?vue&type=template&id=0ce3917e"
import script from "./ParticleSphere.vue?vue&type=script&lang=js"
export * from "./ParticleSphere.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__